import { render, staticRenderFns } from "./M3.vue?vue&type=template&id=b4423c6c&scoped=true"
import script from "./M3.vue?vue&type=script&lang=js"
export * from "./M3.vue?vue&type=script&lang=js"
import style0 from "./M3.vue?vue&type=style&index=0&id=b4423c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4423c6c",
  null
  
)

export default component.exports